export type TableSectionVariant =
  | 'future'
  | 'current'
  | 'default'
  | 'modelCalibrationCurrent'
  | 'historicalErrorCurrent'
  | 'historicalErrorFuture';

export type SectionVariantStyle = {
  cohortColor: string;
  cohortBg: string;
  rowBg: string;
  boxed: boolean;
};

export const ROW_COLORS = ['#D8DBDD', '#FFFFFF', '#F0F0F1'];

export const SECTION_VARIANT_STYLES: Record<TableSectionVariant, SectionVariantStyle> = {
  future: {
    cohortColor: '#7C5CBF',
    cohortBg: '#EDE8F7',
    rowBg: '#F8F6FC',
    boxed: false,
  },
  current: {
    cohortColor: '#2F736E',
    cohortBg: '#DFE9E9',
    rowBg: '#EFF4F4',
    boxed: false,
  },
  modelCalibrationCurrent: {
    cohortColor: '#2F736E',
    cohortBg: '#DFE9E9',
    rowBg: '#FFFFFF',
    boxed: false,
  },
  historicalErrorCurrent: {
    cohortColor: '#2F736E',
    cohortBg: '#DFE9E9',
    rowBg: '#FFFFFF',
    boxed: false,
  },
  historicalErrorFuture: {
    cohortColor: '#7C5CBF',
    cohortBg: '#EDE8F7',
    rowBg: '#FFFFFF',
    boxed: false,
  },
  default: {
    cohortColor: '#1B1C17',
    cohortBg: '#FFFFFF',
    rowBg: '#FFFFFF',
    boxed: false,
  },
};
